import React from 'react';
import { Button, Glyphicon, Modal } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import tvtApi from '../../services/tvt-api';

import ForgotPasswordForm from './ForgotPasswordForm';

import './ForgotPassword.css';

export const USER_REQUIRED = 'Username is required.';

export default class ForgotPassword extends React.Component {
  state = {
    show: false,
    loading: false,
    success: false,
    error: false
  };

  handleShow = () => this.setState({ show: true });

  handleClose = () => this.setState({ show: false });

  validate = ({ username }) => ({
    username: isEmpty(username) ? USER_REQUIRED : null
  });

  submit = async ({ username }) => {
    try {
      this.setState({
        ...this.state,
        loading: true,
        success: false,
        error: false
      });
      const result = await tvtApi.forgotPassword(username);
      if (!result.success) {
        throw Error(result.error);
      }
      this.setState({ ...this.state, loading: false, success: true });
    } catch (error) {
      this.setState({
        ...this.state,
        loading: false,
        error:
          'Error: We were unable to process your request. Please try again or contact support.'
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <span
          role="presentation"
          className="tvt-login__forgot-pwd"
          onClick={this.handleShow}
        >
          {this.props.title}
        </span>
        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          dialogClassName="tvt-forgot-password"
        >
          <Button
            className="tvt-forgot-password__close"
            onClick={this.handleClose}
          >
            <Glyphicon glyph="remove" />
          </Button>
          <h1 className="tvt-forgot-password__header">{this.props.title}</h1>
          <h2 className="tvt-forgot-password__subheader">
            Please enter your username below and we will email you a link to
            reset your password.
          </h2>
          <ForgotPasswordForm
            loading={this.state.loading}
            success={this.state.success}
            error={this.state.error}
            onClose={this.handleClose}
            onSubmit={this.submit}
            validate={this.validate}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

ForgotPassword.propTypes = {
  title: PropTypes.string
};

ForgotPassword.defaultProps = {
  title: 'Forgot Password?'
};
